import React from "react";
import { connect } from "react-redux";
import { Provider } from "react-redux";
import store from "../../../stores/reduxStore";
import * as actions from "../../../actions/actions";
import { withRouter } from "react-router";

import StripeUpgradeForm from "../stripe-upgrade-form";
import BillingCycleSelection from "../billing-cycle-selection";
import Seats from "../seats";
import PriceExplanation from "../price-explanation";
import OptionalBillingInfo from "../optional-billing-info";
import ProFeatures from "../pro-features";
import OtherSignupLinks from "../other-signup-links";

const AccountPrice = ({ yearlyPrice, monthlyPrice }) => {
    return (
        <div>
            <i className="ui_team-accounts plan-team font-xlarge" />
            <h1 className="font-xxlarge font-bold margin-b-l">NounTeam</h1>
            <div className="price">
                {yearlyPrice === 99.9 ? (
                    <div className="price-sign-style wider">
                        <div className="price-dollar-sign">$</div>
                        <div className="price-dollars-bold">99</div>
                        <div className="price-cents-underline price-team">
                            90
                        </div>
                        <div className="price-stacked-type">
                            per member billed yearly
                        </div>
                    </div>
                ) : (
                    <div>${yearlyPrice} per member billed yearly</div>
                )}

                <span className="font-xsmall color-grey">
                    or ${monthlyPrice} per member per month
                </span>
            </div>
        </div>
    );
};

class TeamSignup extends React.Component {
    constructor(props) {
        super(props);

        this.props.stripeNumSeatsChange(this.props.seats, this.props.minSeats);
        if (this.props.couponCode) {
            this.props.stripeCouponCodeChange(this.props.couponCode);
            this.props.stripeCouponCodeCheck();
        }
    }

    componentDidMount() {
        this.props.getUser();
    }

    state = {
        planKey: "team-yearly"
    };

    choosePlan = planKey => {
        this.setState({ planKey });
    };

    createTeam = (stripeApi, tokenData) => {
        return this.props.submit(
            stripeApi,
            this.props.match.params.username,
            this.props.seats,
            tokenData,
            this.state.planKey
        );
    };

    afterThankYou = () => {
        this.redirectToSeatsPage();
    };

    redirectToSeatsPage = () => {
        this.props.redirect(
            `/${this.props.match.params.username}/settings/seats`
        );
    };

    showBillingInfoInput = e => {
        e.preventDefault();
        this.setState({ showBillingInfoInput: true });
    };

    render() {
        let { plans, coupon } = this.props;
        let { planKey } = this.state;

        let period = planKey.split("-").pop();
        let plan = plans && plans[period];

        const price = plan.price;
        const currentPlan = { ...plan };

        // If the user has entered a valid seat count, show the price based on that
        if (this.props.seats >= this.props.minSeats) {
            currentPlan.price = price * this.props.seats;
        } else {
            currentPlan.price = price * this.props.minSeats;
        }

        return (
            <div id="billing">
                <div id="stripe-form" className="no-ui-icon">
                    <section className="main-billing">
                        <div className="container row">
                            <div
                                id="account-price"
                                className="columns six account-price"
                            >
                                <AccountPrice
                                    yearlyPrice={this.props.plans.yearly.price}
                                    monthlyPrice={
                                        this.props.plans.monthly.price
                                    }
                                />
                                {this.props.coupon ? (
                                    <p className="team-discount">
                                        Your enterprise team will <br />
                                        receive a <span /> discount.
                                    </p>
                                ) : null}
                                <ProFeatures />
                                {!this.props.coupon ? (
                                    <OtherSignupLinks />
                                ) : null}
                            </div>
                            <ul className="team-signup new-form columns six">
                                <StripeUpgradeForm
                                    showThankYou
                                    thankYouTitle="Thanks for your Team subscription!"
                                    planKey={this.state.planKey}
                                    onSuccess={this.afterThankYou}
                                    submitOverride={this.createTeam}
                                    buttonText="Finish like a boss"
                                >
                                    {({
                                        form,
                                        submitButton,
                                        billingInfo,
                                        error
                                    }) => {
                                        return (
                                            <div className="team-signup-form">
                                                <li>
                                                    <ol>
                                                        <Seats
                                                            minSeats={
                                                                this.props
                                                                    .minSeats
                                                            }
                                                            coupon={
                                                                this.props
                                                                    .coupon
                                                            }
                                                        />
                                                        <BillingCycleSelection
                                                            plans={
                                                                this.props.plans
                                                            }
                                                            choosePlan={
                                                                this.choosePlan
                                                            }
                                                            subscriptionType="team"
                                                        />
                                                        <ol className="payment-information">
                                                            {form}
                                                            <OptionalBillingInfo>
                                                                {billingInfo}
                                                            </OptionalBillingInfo>
                                                            <li className="footer margin-t-l">
                                                                <PriceExplanation
                                                                    currentPlan={
                                                                        currentPlan
                                                                    }
                                                                    coupon={
                                                                        coupon
                                                                    }
                                                                    period={
                                                                        period
                                                                    }
                                                                />
                                                            </li>
                                                        </ol>
                                                    </ol>
                                                </li>
                                                <li className="margin-t-l">
                                                    {submitButton}
                                                </li>
                                                {error}
                                            </div>
                                        );
                                    }}
                                </StripeUpgradeForm>
                            </ul>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let { stripe } = state;
    let { coupon, seats } = stripe;

    // Set seats to user entered amount, or to minSeats initially
    seats = seats || ownProps.minSeats;
    return {
        seats,
        coupon
    };
};

const WrappedForm = connect(mapStateToProps, {
    stripeCouponCodeChange: actions.stripeCouponCodeChange,
    stripeCouponCodeCheck: actions.stripeCouponCodeCheck,
    stripeNumSeatsChange: actions.stripeNumSeatsChange,
    submit: actions.createTeam,
    getUser: actions.getCurrentUser,
    redirect: actions.redirect
})(TeamSignup);

export { WrappedForm };

export default withRouter(function(props) {
    return (
        <Provider store={store}>
            <WrappedForm {...props} />
        </Provider>
    );
});
